module.exports = __webpack_public_path__ + "img/tema1-5-ico1.d1d7d80e.svg";